import { Navigate, useRoutes } from "react-router-dom"
import { ConfirmPage } from "../ConfirmPage"
import { ErrandTakePhotoPage } from "../ErrandTakePhotoPage"
import { ListTroublesPage } from "../ListTroublesPage"
import { DetailsPage } from "@/pages/CleaningInfoPage/DetailsPage"
import { ErrandPage } from "@/pages/CleaningInfoPage/ErrandPage"

const routes = [
    {
        path: `errand`,
        element: <ErrandPage />
    },
    {
        path: `info`,
        element: <DetailsPage />
    },
    {
        path: `list-troubles`,
        element: <ListTroublesPage />
    },
    {
        path: `trouble/end`,
        element: <ConfirmPage />
    },
    {
        path: `errand/take-photo/:id`,
        element: <ErrandTakePhotoPage />
    },
    {
        path: "/*",
        element: <Navigate to="info" />
    }
]

export const CleaningInfoRoutes = () => {
    const element = useRoutes(routes)
    return element
}
